import {React, useContext, useState, useEffect } from "react";
import UserContext from "../context/UserContext";
import {UserProvider} from "../context/UserContext";
import ThemeContext from "../context/ThemeContext";
import Profile from "../components/Profile";
import Sidebar from "../components/Sidebarstr";

import SternaSide from "../components/sidebars/sterna/SternaSide";
import { Outlet } from "react-router";







const Home2 = () => {

  const {theme, setTheme} = useContext(ThemeContext);
  const {loginuser, setLoginUser} = useContext(ThemeContext);
  console.log(theme);

  const { users, setUsers } = useContext(UserContext);
    
  useEffect(() => {
      setUsers((prevUsers) => ({
        ...prevUsers,
        placeSide: "3"
      }));
    }, []);
  return <div>
    
     <Sidebar />
     <Outlet />
    
  
   <h2> contextden gelen veri: {theme}</h2>
   <button onClick={() => setTheme("murat g")}>change</button> 
  
  

    <div><h1 className="text-center from-cyan-300 font-bold underline">
    
   
    Hello world! {loginuser}  </h1>
  
   
      <button onClick={() => setTheme(localStorage.getItem("login"))}>
        Click me
      </button>
      
      <h1>Hello world {loginuser} </h1>;
      
      <div>
      <label htmlFor="price" className="block text-sm font-medium leading-6 text-gray-900">
        Price
      </label>
      <div className="relative mt-2 rounded-md shadow-sm">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <span className="text-gray-500 sm:text-sm">$</span>
        </div>
        <input
          type="text"
          name="price"
          id="price"
          className="block w-full rounded-md border-0 py-1.5 pl-7 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          placeholder="0.00"
        />
        <div className="absolute inset-y-0 right-0 flex items-center">
          <label htmlFor="currency" className="sr-only">
            Currency
          </label>
          <select
            id="currency"
            name="currency"
            className="h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm"
          >
            <option>USD</option>
            <option>CAD</option>
            <option>EUR</option>
          </select>
        </div>
      </div>
    </div>
      < SternaSide />
      <Profile />

      
      
 
</div>
</div>
   
};

export default Home2;